const playVideo = (video) => {
  const cover = video.querySelector('[data-video-overlay]');
  const spinner = video.querySelector('[data-video-spinner]');
  const trigger = video.querySelector('[data-video-trigger]');

  const player = video.querySelector('video');

  trigger.addEventListener('click', (e) => {
    cover.style.display = 'none';
    spinner.style.display = 'none';
    trigger.style.display = 'none';

    player.play();
  });
};

export default playVideo;
